require('./styles/main.scss');
require('./styles/flexbox.scss');

import React, { Component, PropTypes } from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import Main from './containers/Main'
import App from './containers/App'
import HighscoreContainer from './containers/HighscoreContainer'
import About from './containers/About'
import UnderConstruction from './containers/UnderConstruction'
import ChallengeMakerContainer from './containers/ChallengeMakerContainer'
import { Router, Route, Link, browserHistory } from 'react-router'
import configureStore from './store/configureStore'
const store = configureStore()


class challengeWrapper extends Component {
  render() {
    return <App isChallenge = { true } />
  }
}

class highscoreWrapper extends Component {
  render() {
    return <HighscoreContainer store = { store } />
  }
}

render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={Main}>
        <Route path="about" component={About}/>
        <Route path="challenge" component={challengeWrapper}/>
        <Route path="makeChallenge" component={ChallengeMakerContainer}/>
        <Route path="highscore" component={highscoreWrapper}/>
        <Route path="classic" component={App}/>
        <Route path="*" component={App}/>
        <Route path="" component={App}/>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./index.js